import styled from "styled-components";

//prettier-ignore
export const StyledPreview = styled.div<{ mainColor?: string; subColor?: string; showConfirm: boolean; }>`
    
    background-color: inherit;
    border-radius: 4px;
    margin-bottom: 1.5rem;
    ${(p) => {
        if (p.showConfirm) return "height:98vh; overflow:hidden;";
    }}
    
    .header {
        padding: 24px;
        display: flex;
        align-items: center;
        background-color: inherit;
        span {
            display: inline-block;
            margin-left: 12px;
            font-weight: 600;
            font-size: 25px;
            line-height: 33px;
        }
    }
    .page_body {
        position: relative;
        .pagination {
            z-index: 2;
            background-color: inherit;
            position: absolute;
            top: 1rem;
            right: 1rem;
            border-radius: 1rem;
            padding: 0 10px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakOnlyMobile}) {
            height: 100vh;
            overflow-y: auto;
            padding-bottom: 30px;
            display: flex;
            flex-direction: column;
            ::-webkit-scrollbar {
                width: 4px;
                height: 4px;
            }

            ::-webkit-scrollbar-track {
                box-shadow: inset 0 0 5px grey;
                border-radius: 10px;
            }

            ::-webkit-scrollbar-thumb {
                border-radius: 10px;
            }

            ::-webkit-scrollbar-thumb:hover {
                cursor: grab;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakOnlyMobile}) {
            padding-bottom: 32px;
        }
    }
    .body,
    .body_freePoint {
        height: 160px;
        overflow: hidden;
        min-height: 150px;
        background-color: ${(p) => p.mainColor};
        position: relative;
        /* max-width: calc(100% - 30px); */
        width: 90%;
        overflow: hidden;
        margin: 24px auto 0 auto;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        .text_name {
            /* position: absolute; */
            top: 22px;
            left: 25px;
            padding: 25px;
            
            .name {
                line-height: 1.8rem;
                max-width: 290px;
                color: ${(p) => p.theme.colors.background} !important;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
     
            }
            .date_text {
                line-height: 1.5rem;
                color: ${(p) => p.theme.colors.background} !important;
                margin-top: 10px;                
            }
            .nick_name {
                padding: 4px 18px;
                color: ${(p) => p.theme.colors.background} !important;
                background: rgba(0, 0, 0, 0.22);
                border-radius: 17px;
                margin-top: 10px;
                text-align: center;
                min-width: 120px;
                width: fit-content;
                cursor: pointer;
              
            }
        }
    }
    .body_freePoint {
        height: 125px;
        min-height: 125px;
    }
    .code {
        display: flex;
        padding: 18px 25px;
        background-color: inherit;
        align-items: center;
        width: calc(100% - 30px);;
        margin: 0 auto 16px auto;
        /* max-width: 100%; */
      
        .coupon_code {
            min-width: fit-content;
            font-style: normal;
            /* font-weight: normal; */
            font-size: 16px;
            line-height: 19px;
            color: #717171;
            margin-right: 12px;
        }
        .number {
            font-style: normal;
            /* font-weight: 400; */
            /* font-size: 20px; */
            line-height: 27px;
            color: #000000;
            width: 170px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        
    }
    .content {
        width: calc(100% - 30px);;
        margin: 0 auto;
        border-radius: 8px;
        padding: 28px 20px;
        background-color: inherit;
        position: relative;
        .pagination_coupon {
            z-index: 2;
            background-color: inherit;
            position: absolute;
            top: 1rem;
            right: 1rem;
            border-radius: 1rem;
            padding: 0 10px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        }
        .image {
            width: 100%;
            height: calc(100vw - 64px);
            max-height: 416px;
            object-fit: cover;
            border-radius: 4px;
        }
        .guideline {
         
            font-style: normal;
            line-height: 1.5rem;
            margin-top: 24px;
            word-break: break-word;
            * {                
                font-size: inherit;
                font-weight: inherit;
                line-height: 1.5rem;
            }
        }
    }
    .btn-main {
        width: calc(100% - 30px);;
        margin: 0 auto;
    }
    //update
    .img-field {
        .img-wrap {
            background-color: inherit;
            overflow: hidden;
            max-height: 400px;
            display: flex;
            justify-content: center;
            img {
                object-fit: cover;
                width: 100%;
                object-position: center;
                height: 400px;
            }
        }
    }
    .name-field {
        padding: 15px;
        margin-bottom: 8px;
        color: #a8a8a8;
        background-color:#fff;
        p {
            
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            font-weight: normal;
            font-size: 14px;
            margin-bottom: 0px;
        }
    }
    .layout-select-field {
        background-color:#fff;
        div {
            &:last-child {
                border-bottom: none;
            }
        }
    }
    .quantity-field {
        padding: 15px 0px;
        margin: 0 15px;
        background-color:#fff;
        border-bottom: 0.5px solid #e1e1e1;
        .count-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
                margin: 0 8px;
                color: inherit;
                font-style: normal;
           
            }
            .item-left {
                .item-left-top {
                    display: flex;
                    align-items: center;
                }
            }
            .item-right {
                display: flex;
                align-items: center;
                .btn-minus,.btn-add {
                    
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    border-width: 0px;
                    box-shadow:  4px 3px 5px 0px rgb(0 0 0 / 15%), 3px 1px 20px 20px rgb(239 230 230 / 20%);
                    cursor: pointer;
                    background-color: inherit;
                    color: inherit;
                    font-weight: 500;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background:  ${(p) => p.theme.colors.white} !important;
                    color:  ${(p) => p.theme.colors.black} !important;
                    /* border: 1px solid black; */
                }
                div:active {
                    transform: scale(0.95);
                }
            }
        }
    }
    .select-field {
        cursor: pointer;
        padding: 15px 0px;
        margin: 0 15px;
        border-bottom: 0.5px solid #e1e1e1;
        background-color:#fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .select-label{
            display: flex;
            align-items: center;
        }
        .select-opts {
            width: 100%;
            margin-top: 6px;
            div {
                border-color: transparent !important;
            }
        }
        .arrowRight {
            cursor: pointer;
            display: flex;
            align-items: center;
            .select_type{
                margin-right: 4px;
            }
        }
        .variant {      
            font-style: normal;
            /* font-weight: normal; */
            /* font-size: 20px; */
            margin: 0 8px;
            line-height: 1.8rem;
            color: #000000;
        }
    }
    .description-field {
        word-break: break-word;
        background-color: #fafafa;
        flex: 1;
        padding: 15px;
        max-width: 100%;
        word-break: break-all;
        p,
        div {
            font-style: normal;                        
            color: inherit;
            line-height: 1.5rem;
        }
        .use_point{
           width: 100%; 
        }
    }
    .text-small {
        font-size: 10px;
        font-weight: 600;
        color: #9d9d9d;
        font-style: normal;
        font-weight: normal;
      
        margin-top: 4px;
    }
    h5 {
        word-break: break-word;
        color: inherit;
        display: -webkit-box;
        max-width: 100%;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        font-style: normal;
        line-height: 36px;
    
    }
    .use_point {
        text-align: center;
        margin-right: 12px;
    }
    .ant-select-selection__rendered {
        color: #000000;
        font-size: 20px;
   
    }
    .select_type {
        color: #929292;
        font-style: normal;
        /* font-weight: 600; */
        /* font-size: 10px; */
     
    }
    .variant {
        color: #000000;
        font-style: normal;
        /* font-weight: normal; */
        /* font-size: 20px; */
      
    }
    .swiper-slide.swiper-slide-active {
        overflow: hidden;
        /* border-radius: 6px; */
        width: 100%;
    }
    /* .swiper-slideswiper-slide-active */
    .swiper-pagination-bullet {
        opacity: 0.6;
    }
    .swiper-pagination-bullet-active {
        background-color: inherit;
        opacity: 1;
    }
    .swiper-container-horizontal>.swiper-scrollbar{
        display: none;
    }
`;
